import * as Config from '../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import '../../../playlist/Playlist.css';

import ListV2 from '../../../content/list/ListV2';

import Sample from './Sample';

import { connect } from "react-redux";

function ConnectedPlaylist({
  style, data = [], width, height, isMinimizePlaylist
}) {
  const pad = 42;
  const padSampleList = 47;
  // const bestHeight = isMinimizePlaylist ? height - pad : height - (160 + pad); // with video
  const bestHeight = isMinimizePlaylist ? height - pad : height - (160 + padSampleList); // without video
  const sizeCover = Config.PLAYLIST_COVER_SIZE + pad;
  // const samplersHeight = sizeCover - pad; // with video
  const samplersHeight = sizeCover - (pad * 2); // without video

  return (
      <div className={`flexColumn playlist-page ${isMinimizePlaylist && `minimize` }`} style={{ ...style }}>
        { !isMinimizePlaylist && (
          <div className={`flexRow card-container-playlist`} style={{height: samplersHeight}}>
            <div className={`flexColumn`} style={{position: `absolute`, left: 30}}>
              <div className={`flexRow`} style={{}}>
                <Sample name={`Air Horn`} />
                <Sample name={`Uhh`} />
                <Sample name={`Echo Bleep`} />
                <Sample name={`Chord 1`} />
              </div>
              <div className={`flexRow`} style={{}}>
                <Sample name={`Spaceship`} />
                <Sample name={`Impact`} />
                <Sample name={`Chord 2`} />
                <Sample name={`Radiobytes`} />
              </div>
            </div>
            <div className={`flexColumn`} style={{position: `absolute`, right: 46}}>
              <div className={`flexRow`} style={{}}>
                <Sample name={`Drum Hat`} />
                <Sample name={`Cymbal`} />
                <Sample name={`Drum Kick`} />
                <Sample name={`Drum Snare`} />
              </div>
              <div className={`flexRow`} style={{}}>
                <Sample name={`Vox 1`} />
                <Sample name={`DJ`} />
                <Sample name={`House Kick`} />
                <Sample name={`House Clap`} />
              </div>
            </div>
          </div>
        )}

        <div className={`content-container`} style={{ width, marginTop: isMinimizePlaylist ? 16 : pad + padSampleList }} >
          <ListV2
            id={`musicalfree`}
            pathApi={null}
            data={data}
            sortable={false}
            width={width + 30}
            height={bestHeight}
            size={Config.LIST_ROW_HEIGHT}
            style={{ marginTop: 0 }}
            filtersStyle={{ display: `none`, top: 0, right: 0 }}
            panelStyle={{ top: 140 }}
            filters={[]}
            type={`Partial`}
            enableKeys={false}
            enableShortcuts={false}
            orderBy={[]}
            isBoost={true}
            automix={false}
            from={`/`}
            isLoadMore={true}
            dnd={false}
          />
        </div>
      </div>
    )
}

ConnectedPlaylist.propTypes = {
  data: PropTypes.array.isRequired,
  width: PropTypes.any,
  height: PropTypes.any,
  style: PropTypes.object,
}

const Playlist = connect(
  state => ({
    width: state.dimension.width,
    height: state.dimension.height,
    isMinimizePlaylist: state.IMinimizePlaylist
   })
)(ConnectedPlaylist);

export default Playlist;
